<template>
  <ontos-base v-bind="baseProps" ref="base">
    <v-form v-if="loaded && domain">
      <ontos-page-header v-bind="heading"/>
      <v-row>
        <v-col cols="12">
          <ontos-domain-input ref="input" :value="domainOnChange" @input="domainOnChange = $event"
                              :domains="workspace.domains" fixed-alias/>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn size="small" color="primary" @click="save()" :disabled="edit.unchanged">
            <v-icon start>mdi-content-save</v-icon>
            {{ $tt('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </ontos-base>
</template>
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import DomainInput from "@/components/design/domain/DomainInput.vue";
import {DraftState, draftState} from "@/utils/modelUtils";
import Domain, {emptyDomain} from "@/types/Domain";
import {deepCopy} from "@/utils/copy";
import DomainLevelRouteComponent from "@/components/shared/DomainLevelRouteComponent";
import {domainDesign} from "@/utils/heading";
import {domainErrorMessage} from "@/utils/domainErrors";

@Component({components: {'ontos-domain-input': DomainInput}})
class EditDomain extends DomainLevelRouteComponent {
  get heading() {
    return domainDesign(this.domain!)
  }

  domainOnChange: Domain = emptyDomain()
  declare $refs: {input: InstanceType<typeof DomainInput>}

  /** Só os dados: a cópia enriquecida traz métodos, que não são o que se edita. */
  private get plainDomain(): Domain {
    const {alias, name, options} = this.domain
    return {alias, name, options}
  }

  async load() {
    if (!this.domain) {
      this.throwError(this.$tt('error.load-domain', {name: this.$route.params.domain}))
      return
    }
    this.domainOnChange = deepCopy(this.plainDomain) //copia e deixa reativa
  }

  async save() {
    const name = this.domain.name
    try {
      if (this.$refs.input.validateModel()) {
        await this.updateCurrentDomain(this.edit.changes)
        this.info(this.$tt('info.domain-updated', {name}))
        await this.$router.push({name: 'view-domain', params: {...this.$route.params, domain: this.domain.alias}})
      }
    } catch (err) {
      this.throwError(domainErrorMessage(err, this.$tt('error.update-domain', {name})), err)
    }
  }

  /** O que mudou e se o salvar habilita — a regra mora no `draftState` */
  get edit(): DraftState {
    return draftState(this.plainDomain, this.domainOnChange)
  }
}

export default toNative(EditDomain)
</script>
